export default {
  SET_COURSE_REPORT(state, report) {
    state.courseReport = report
  },
  SET_LESSON_REPORT (state, report) {
    state.lessonReport = report
  },
}
